/* Shipping destination modal (snippets/shipping-to-modal.liquid). Opened by any
 * [data-shipping-to-open]; on a first visit it opens itself to suggest the
 * visitor's detected country, or to welcome international visitors. */
if (!customElements.get('shipping-to')) {
  const DISMISSED_KEY = 'shipping-to-dismissed';

  customElements.define(
    'shipping-to',
    class ShippingTo extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.search = this.querySelector('[data-shipping-to-search]');
        this.items = [...this.querySelectorAll('[data-country-item]')];

        this.onOpen = (event) => {
          if (!event.target.closest('[data-shipping-to-open]')) return;
          event.preventDefault();
          this.open('welcome');
        };
        document.addEventListener('click', this.onOpen);

        this.querySelectorAll('[data-shipping-to-close]').forEach((button) =>
          button.addEventListener('click', () => this.close())
        );
        this.querySelector('[data-shipping-to-step="select"]')?.addEventListener('click', () => {
          this.show('select');
          this.search?.focus();
        });
        // A click on the ::backdrop targets the dialog element itself.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => this.onClosed());
        this.search?.addEventListener('input', () => this.filter());
        // Enter picks the first match instead of submitting the form blank.
        this.search?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.items.find((item) => !item.hidden)?.querySelector('button')?.click();
        });

        if (this.dataset.autoPopup === 'true') this.maybeSuggest();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOpen);
      }

      show(step) {
        this.querySelectorAll('[data-step]').forEach((panel) => {
          panel.hidden = panel.dataset.step !== step;
        });
      }

      open(step) {
        this.show(step);
        if (!this.dialog.open) {
          this.dialog.showModal();
          document.body.style.overflowY = 'hidden';
        }
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.onClosed();
      }

      onClosed() {
        document.body.style.overflowY = '';
        try {
          localStorage.setItem(DISMISSED_KEY, '1');
        } catch {}
      }

      filter() {
        const query = this.search.value.trim().toLowerCase();
        let shown = 0;
        this.items.forEach((item) => {
          const match = !query || item.dataset.name.includes(query) || item.dataset.code.toLowerCase() === query;
          item.hidden = !match;
          if (match) shown += 1;
        });
        // Popular / All headings only make sense for the unfiltered list.
        this.querySelectorAll('[data-shipping-to-group]').forEach((heading) => {
          heading.hidden = Boolean(query);
        });
        this.querySelector('[data-shipping-to-empty]').hidden = shown > 0;
      }

      // First visit only: suggest the detected country when it differs from the
      // current one; otherwise welcome visitors outside the store's home country.
      async maybeSuggest() {
        if (window.Shopify?.designMode) return;
        try {
          if (localStorage.getItem(DISMISSED_KEY)) return;
        } catch {
          return;
        }

        const current = this.dataset.current;
        let detected = null;
        try {
          const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true');
          detected = (await response.json())?.detected_values?.country?.handle || null;
        } catch {}

        const detectedItem = detected && this.items.find((item) => item.dataset.code === detected);
        if (detectedItem && detected !== current) {
          const name = detectedItem.querySelector('button span').textContent.trim();
          this.querySelector('[data-shipping-to-title]').textContent = this.dataset.suggestTitle.replace('[country]', name);
          this.querySelector('[data-shipping-to-text]').textContent = this.dataset.suggestText;
          this.querySelector('[data-shipping-to-message]')?.setAttribute('hidden', '');
          const switchButton = this.querySelector('[data-shipping-to-switch]');
          switchButton.value = detected;
          switchButton.disabled = false;
          switchButton.textContent = this.dataset.switchLabel.replace('[country]', name);
          switchButton.hidden = false;
          // The primary action is now "switch"; keep "stay" as the quiet option.
          const stay = this.querySelector('[data-shipping-to-stay]');
          stay.classList.remove('button--primary');
          stay.classList.add('button--secondary');
          this.open('welcome');
        } else if (current && current !== this.dataset.primary) {
          this.open('welcome');
        }
      }
    }
  );
}
